import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled from 'styled-components';
import { theme } from "../../theme";
import { usePrevious } from "../../hooks";
import { transparentize } from 'polished';
import { getBackgroundColor } from "../../theme/color-tokens";
var _theme$transitions = theme.transitions,
    eases = _theme$transitions.eases,
    durations = _theme$transitions.durations;
export function LinearProgress(_ref) {
  var value = _ref.value,
      _ref$trackColor = _ref.trackColor,
      trackColor = _ref$trackColor === void 0 ? 'brandPrimary' : _ref$trackColor,
      _ref$shadowHeight = _ref.shadowHeight,
      shadowHeight = _ref$shadowHeight === void 0 ? 0 : _ref$shadowHeight,
      other = _objectWithoutProperties(_ref, ["value", "trackColor", "shadowHeight"]);

  var prevValue = usePrevious(value);
  var styles = {
    transition: value < prevValue ? "background-color  ".concat(eases.primary) : "transform ".concat(durations[300], " linear, background-color ").concat(durations[300], "  ").concat(eases.primary),
    transform: "translateX(".concat(value - 100, "%)")
  };
  return /*#__PURE__*/React.createElement(Container, _extends({}, other, {
    $height: shadowHeight,
    $shadow: shadowHeight > 0
  }), /*#__PURE__*/React.createElement(Root, {
    "aria-valuenow": Math.round(value),
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    role: "progressbar"
  }), /*#__PURE__*/React.createElement(AnimatedContainer, {
    style: styles
  }, /*#__PURE__*/React.createElement(Bar, {
    $color: trackColor
  }), shadowHeight > 0 ? /*#__PURE__*/React.createElement(Shadow, {
    $color: trackColor
  }) : null));
}
var AnimatedContainer = styled.div.withConfig({
  displayName: "LinearProgress__AnimatedContainer",
  componentId: "vapor__sc-1r1rgve-0"
})(["position:absolute;top:0;left:0;bottom:0;width:100%;height:100%;transform-origin:left;"]);

function getShadowHeight(height) {
  var _theme$spaces$height;

  return (_theme$spaces$height = theme.spaces[height]) !== null && _theme$spaces$height !== void 0 ? _theme$spaces$height : height;
}

var Container = styled.div.withConfig({
  displayName: "LinearProgress__Container",
  componentId: "vapor__sc-1r1rgve-1"
})(["--fio-progress-radius:", ";position:relative;overflow:hidden;border-radius:var(--fio-progress-radius);height:", ";"], function (p) {
  return p.$shadow ? 0 : theme.radii[8];
}, function (p) {
  return p.$shadow ? "".concat(getShadowHeight(p.$height)) : theme.spaces[4];
});
var Bar = styled.div.withConfig({
  displayName: "LinearProgress__Bar",
  componentId: "vapor__sc-1r1rgve-2"
})(["position:absolute;top:0;left:0;width:100%;height:", ";border-radius:var(--fio-progress-radius);background-color:", ";"], theme.spaces[4], function (p) {
  return getBackgroundColor(p.$color);
});
var Shadow = styled.div.withConfig({
  displayName: "LinearProgress__Shadow",
  componentId: "vapor__sc-1r1rgve-3"
})(["height:100%;width:100%;background:linear-gradient( 180deg,", " 0%,", " 100% );opacity:0.11;"], function (p) {
  return getBackgroundColor(p.$color);
}, function (p) {
  return transparentize(0.9, getBackgroundColor(p.$color));
});
var Root = styled.div.withConfig({
  displayName: "LinearProgress__Root",
  componentId: "vapor__sc-1r1rgve-4"
})(["border-radius:var(--fio-progress-radius);height:", ";background-color:", ";"], theme.spaces[4], theme.colors.palette.whiteA20);